// The live channel (doc/feature/realtime.md): one `GET /live` stream per signed-in tab. Each server
// event is republished as `Fez.publish('live:<event>', data)`; a component that cares subscribes
// with `this.subscribe('live:change', ...)`, and fez drops the subscription with the component.
//   live:change {containers: ['ctr_..']} or {all: true}   writes committed; reload what shows them
//   live:mail   {container, mailbox, email, thread, from_name, from_addr, subject}
//                                                    new mail reached a mailbox's Inbox
//   live:access {}                                       the mailboxes or orgs I reach changed
//   live:calendar {}                                     one of my personal events changed

const EVENTS = ['change', 'mail', 'access', 'calendar']

let source = null

/** Opens the stream once. The browser reconnects a dropped one, and then every view reloads. */
export function connectLive() {
  if (source) return
  let dropped = false
  source = new EventSource('/live')
  source.addEventListener('error', () => {
    dropped = true
  })
  source.addEventListener('open', () => {
    // Personal events have no container: a reconnect reloads them too.
    if (dropped) {
      window.Fez.publish('live:change', { all: true })
      window.Fez.publish('live:calendar', {})
    }
    dropped = false
  })
  for (const name of EVENTS) {
    source.addEventListener(name, (event) => window.Fez.publish(`live:${name}`, event.data ? JSON.parse(event.data) : {}))
  }
}

export function disconnectLive() {
  source?.close()
  source = null
}

/** The container refs of `refs` a `live:change` touches. */
export function touched(change, refs) {
  return change.all ? refs : refs.filter((ref) => change.containers.includes(ref))
}

/** More messages than this for one mailbox in one burst show as one grouped notification. */
export const GROUP_OVER = 3

/** Who a `live:mail` is from: the sender's name, else their address. */
export function senderOf(mail) {
  return mail.from_name?.trim() || mail.from_addr || 'Unknown sender'
}

/**
 * The desktop notifications one burst of `live:mail` events for a mailbox shows: one per message
 * (sender, subject), or over GROUP_OVER one grouped note naming the first senders. `tag` (the
 * conversation, or the mailbox for a group) makes a repeat replace the note; `thread` is what a
 * click opens ('' for the mailbox Inbox).
 */
export function mailNotices(mails, mailboxName) {
  const where = `In ${mailboxName}`
  if (mails.length > GROUP_OVER) {
    const senders = [...new Set(mails.map(senderOf))]
    const more = senders.length - GROUP_OVER
    const names = senders.slice(0, GROUP_OVER).join(', ') + (more > 0 ? ` and ${more} more` : '')
    return [{ title: `${mails.length} new messages`, body: `${names}\n${where}`, tag: mails[0].mailbox, thread: '' }]
  }
  return mails.map((mail) => ({ title: senderOf(mail), body: `${mail.subject?.trim() || '(no subject)'}\n${where}`, tag: mail.thread, thread: mail.thread }))
}
